import { type ActiveOn } from './buildNavLinks'

const matchesActiveOnArray = (pathname: string, activeOn: ActiveOn) =>
  Array.isArray(activeOn) ? !!activeOn.find((p) => pathname.startsWith(p)) : pathname.startsWith(activeOn)

export default matchesActiveOnArray
